import { Stack } from '@mantine/core';
import { Text, Title } from '@repo/foundations';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { useMemo } from 'react';
import { DataAccessRequestContent } from '../../../../components/DataAccessRequest/DataAccessRequestContent/DataAccessRequestContent';
import { DataAccessRequestContentSkeleton } from '../../../../components/DataAccessRequest/DataAccessRequestContent/DataAccessRequestContentSkeleton';
import type { IResourceContentProps } from '../../types';

dayjs.extend(relativeTime);

function getExpiringSubtitle(
	metadata: IResourceContentProps['selected']['metadata']
): string | null {
	const expiresAt = metadata?.approved_expires_at;
	const integrationName = metadata?.integration_name;

	if (!expiresAt || !integrationName) {
		return null;
	}

	const expiry = dayjs(expiresAt as string);
	const now = dayjs();

	if (expiry.isBefore(now)) {
		return `Your access to ${integrationName} has expired`;
	}

	return `Your access to ${integrationName} expires ${expiry.fromNow()}`;
}

export function ResourceDataAccessRequestContent({
	selected,
}: IResourceContentProps) {
	const subtitle = useMemo(
		() => getExpiringSubtitle(selected.metadata),
		[selected.metadata]
	);

	return (
		<Stack spacing="2xl">
			<Title size="xl">{selected.resource_title}</Title>
			{subtitle ? (
				<Text size="sm" color="text/secondary/default">
					{subtitle}
				</Text>
			) : null}
			{selected.computedMetadata?.dataAccessRequest ? (
				<DataAccessRequestContent
					request={selected.computedMetadata.dataAccessRequest}
				/>
			) : (
				<DataAccessRequestContentSkeleton />
			)}
		</Stack>
	);
}
